import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';

import * as ACTIONS from './campaign-context-actions';
import { initialState } from './campaign-context-state';

const _campaignContextReducers = createReducer(initialState,
  // Set the current campaign
  produceOn(ACTIONS.SET_CURRENT_CAMPAIGN, (state, props) => {
    state.current_campaign = props.payload;
  })
);

export function campaignContextReducers(state, action) {
  return _campaignContextReducers(state, action);
}
